import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils.js'
import FileUploadWithFileNameModalUI from './FileUploadWithFileNameModalUI.js'

class FileUploadWithFileNameModalSF extends Component {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fileInput = React.createRef();

    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      othersFileName: '',
      othersFileNameError: null
    }
  }

  render() {
    return (
      <FileUploadWithFileNameModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        titleLabel={this.props.titleLabel}
        // modes
        uploadMode={this.props.uploadMode}
        submitted={this.state.submitted}
        // button click handlers
        onCancelClick={this.onCancelClick}
        // form
        fileInput={this.fileInput}
        multiple={this.props.multiple}
        handleSubmit={this.handleSubmit}
        //
        othersFileName={this.state.othersFileName}
        onOthersFileNameChange={(event) => { this.setState({ othersFileName: event.target.value }) }}
        othersFileNameError={this.state.othersFileNameError}
        setOthersFileNameError={(error) => { this.setState({ othersFileNameError: error }) }}
        hint={this.props.hint}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log(`Selected file - ${this.fileInput.current.files[0].name}`)

    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    for (let file of this.fileInput.current.files) {
      this.getFileUploadSignedUrl(file)
    }
  }

  getFileUploadSignedUrl(file) {
    let context = this.props.context
    let getResource = `${RestApiUtils.getServerUrl(context)}${this.props.signedUrlApi}` +
      `?fileName=${file.name}&type=${file.type}&size=${file.size}`
    console.log('-> GET', getResource)

    fetch(getResource, {
      headers: RestApiUtils.getHeaders(context),
    })
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        console.log('<- GET', getResource, json)
        if (json.errorList.length)
          this.setState({ submitted: false, errorList: json.errorList })
        else
          this.uploadFile(json.signedUrl, file)
      })
  }

  uploadFile = (signedUrl, file) => {
    let putResource = signedUrl.signedUrl
    console.log('-> PUT', putResource)
    fetch(putResource, {
      method: 'put',
      body: file,
    })
      .then((response) => {
        console.log('<- PUT', putResource)
        this.props.onUpload(signedUrl.fileId, file.name, file.type, file.size, this.state.othersFileName)
        setTimeout(() => {
          this.setState({
            successMsg: null, submitted: false
          })
          this.onCancelClick()
        }, 1000)
      })
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }

  onCancelClick = () => {
    this.setState({ submitted: false, successMsg: null, errorList: null, othersFileName: '' })
    this.props.onCancelClick()
  }
}

export default withRouter(FileUploadWithFileNameModalSF)
